(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 41633:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(55382);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88349);
/* harmony import */ var _deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51493);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58709);
/* harmony import */ var _commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40300);
/* harmony import */ var _commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98290);
/* harmony import */ var _commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73764);
/* harmony import */ var _components_ProductBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87122);
/* harmony import */ var _deosite_api_hooks_common_useRecentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79105);








var Custom404 = function(props) {
    var translations = {
        seoDescription: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo description"),
        seoTitle: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Default seo title"),
        possibleFailure: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Possible service failure. Please wait a moment and try again."),
        pageNotFound: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Page not found"),
        goToHomePage: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Go to home page"),
        recentlyViewed: (0,_deosite_helpers_langLibrary__WEBPACK_IMPORTED_MODULE_1__["default"])("Check recently viewed")
    };
    var recentlyViewedProducts = (0,_deosite_api_hooks_common_useRecentlyViewedProducts__WEBPACK_IMPORTED_MODULE_7__.useRecentlyViewedProducts)();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_containers_UI_PageContainer__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        metaTagsData: {
            description: translations.seoDescription,
            title: translations.seoTitle
        },
        recentlyViewedActive: false,
        footerContent: props.footerContent,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Container__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                sx: {
                    display: "flex",
                    mt: "s10",
                    color: "main",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    minHeight: "50vh"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                        as: "p",
                        sx: {
                            font: "xxl"
                        },
                        children: translations.pageNotFound
                    }),
                    (recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                        sx: {
                            mt: "s8"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Box__WEBPACK_IMPORTED_MODULE_3___default()), {
                                as: "p",
                                sx: {
                                    color: "main",
                                    font: "base",
                                    my: "s8",
                                    textAlign: "center"
                                },
                                children: translations.recentlyViewed
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((_commerce_ui_core2_Grid__WEBPACK_IMPORTED_MODULE_4___default()), {
                                cols: [
                                    (recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length) / 2,
                                    null,
                                    recentlyViewedProducts === null || recentlyViewedProducts === void 0 ? void 0 : recentlyViewedProducts.length,
                                    null
                                ],
                                sx: {
                                    gridRowGap: "s11"
                                },
                                children: recentlyViewedProducts.map(function(product, index) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductBox__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        product: product
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Custom404);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(41633); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);